<app-ui-modal
  [isOpen]="true"
  [title]="(enseigne() ? 'ENSEIGNES.MODAL_EDIT_TITLE' : 'ENSEIGNES.MODAL_TITLE') | translate"
  (closed)="onCancel()"
>
  <div class="m-enseigne-form">
    <div class="m-enseigne-form__field">
      <label class="m-enseigne-form__label">
        {{ 'ENSEIGNES.FORM.ENSEIGNE_LABEL' | translate }}
        <span class="m-enseigne-form__required">*</span>
      </label>
      <input
        type="text"
        class="m-enseigne-form__input"
        [class.m-enseigne-form__input--error]="submitAttempted() && errors().enseigne"
        [value]="formData().enseigne"
        [required]="true"
        (input)="updateField('enseigne', $any($event.target).value)"
      />
      @if (submitAttempted() && errors().enseigne) {
        <span class="m-enseigne-form__error">
          {{ 'ENSEIGNES.FORM.ERRORS.' + errors().enseigne | translate }}
        </span>
      }
    </div>

    <div class="m-enseigne-form__field">
      <label class="m-enseigne-form__label">
        {{ 'ENSEIGNES.FORM.CODE_ORG_LABEL' | translate }}
        <span class="m-enseigne-form__required">*</span>
      </label>
      <input
        type="text"
        class="m-enseigne-form__input"
        [class.m-enseigne-form__input--error]="submitAttempted() && errors().codeOrg"
        [value]="formData().codeOrg"
        [required]="true"
        [disabled]="isEditMode()"
        (input)="updateField('codeOrg', $any($event.target).value)"
      />
      @if (submitAttempted() && errors().codeOrg) {
        <span class="m-enseigne-form__error">
          {{ 'ENSEIGNES.FORM.ERRORS.' + errors().codeOrg | translate }}
        </span>
      }
    </div>

    <div class="m-enseigne-form__block">
      <app-ui-block
        [title]="'ENSEIGNES.COUNTRIES' | translate"
        addSectionLabel="+ Ajouter un pays"
        (onSectionAdd)="onAddCountry()"
      >
        @for (countryDef of formData().countriesConfig; track $index) {
          <app-ui-section
            [title]="('ENSEIGNES.COUNTRY' | translate) + ' ' + ($index + 1)"
            [removeLabel]="
              formData().countriesConfig.length > 1 ? ('ENSEIGNES.REMOVE_COUNTRY' | translate) : null
            "
            [separator]="$index > 0"
            (onRemove)="onRemoveCountry($index)"
          >
            <div class="m-enseigne-form__field">
              <label class="m-enseigne-form__label">
                {{ 'ENSEIGNES.FORM.PAYS_LABEL' | translate }}
                <span class="m-enseigne-form__required">*</span>
              </label>
              <select
                class="m-enseigne-form__input"
                [class.m-enseigne-form__input--error]="
                  submitAttempted() && errors().countriesConfig[$index]?.country
                "
                (change)="updateCountryField($index, 'country', $any($event.target).value)"
              >
                <option value="" disabled [selected]="!countryDef.country">{{ 'ENSEIGNES.FORM.PAYS_PLACEHOLDER' | translate }}</option>
                @for (code of availableCountryCodes(); track code) {
                  <option [value]="code" [selected]="code === countryDef.country">{{ 'COUNTRY_CODES.' + code | translate }}</option>
                }
              </select>
              @if (submitAttempted() && errors().countriesConfig[$index]?.country) {
                <span class="m-enseigne-form__error">
                  {{ 'ENSEIGNES.FORM.ERRORS.' + errors().countriesConfig[$index].country | translate }}
                </span>
              }
            </div>

            <div class="m-enseigne-form__field">
              <label class="m-enseigne-form__label">
                {{ 'ENSEIGNES.FORM.PREFIX_LABEL' | translate }}
                <span class="m-enseigne-form__required">*</span>
              </label>
              <input
                type="text"
                class="m-enseigne-form__input"
                [class.m-enseigne-form__input--error]="
                  submitAttempted() && errors().countriesConfig[$index]?.prefix
                "
                [value]="countryDef.prefix"
                [required]="true"
                (input)="updateCountryField($index, 'prefix', $any($event.target).value)"
              />
              @if (submitAttempted() && errors().countriesConfig[$index]?.prefix) {
                <span class="m-enseigne-form__error">
                  {{ 'ENSEIGNES.FORM.ERRORS.' + errors().countriesConfig[$index].prefix | translate }}
                </span>
              }
            </div>

            <div class="m-enseigne-form__field">
              <label class="m-enseigne-form__label">
                {{ 'ENSEIGNES.FORM.TRANSPORT_GROUPS_LABEL' | translate }}
                <span class="m-enseigne-form__hint">{{
                  'ENSEIGNES.FORM.TRANSPORT_GROUPS_HINT' | translate
                }}</span>
              </label>
              <input
                type="text"
                class="m-enseigne-form__input"
                [value]="countryDef.transportGroups.join(', ')"
                (input)="updateCountryTransportGroups($index, $any($event.target).value)"
              />
            </div>

            <div class="m-enseigne-form__field">
              <label class="m-enseigne-form__label">{{
                'ENSEIGNES.FORM.SALESFORCE_LABEL' | translate
              }}</label>
              <input
                type="text"
                class="m-enseigne-form__input"
                [value]="countryDef.salesforceRoutingCode"
                [required]="true"
                (input)="
                  updateCountryField($index, 'salesforceRoutingCode', $any($event.target).value)
                "
              />
            </div>

            <div class="m-enseigne-form__field">
              <label class="m-enseigne-form__label">{{
                'ENSEIGNES.FORM.SAP_LABEL' | translate
              }}</label>
              <input
                type="text"
                class="m-enseigne-form__input"
                [value]="countryDef.sapRoutingCode"
                (input)="updateCountryField($index, 'sapRoutingCode', $any($event.target).value)"
              />
            </div>
          </app-ui-section>
        }
      </app-ui-block>
    </div>

    <div class="m-enseigne-form__actions">
      <button class="m-enseigne-form__cancel" (click)="onCancel()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button class="m-enseigne-form__submit" (click)="onSubmit()">
        {{ (enseigne() ? 'COMMON.SAVE' : 'COMMON.CREATE') | translate }}
      </button>
    </div>
  </div>
</app-ui-modal>
